// Types
import { Type, SubType, TypeNames, InsightType } from 'Shared/types/Capture.types';

type getSurfaceTypeNameProps = {
  type: Type;
  subtype: SubType;
};

export const getSurfaceTypeName = ({ type, subtype }: getSurfaceTypeNameProps) => {
  if (type === Type.GOOGLE_DRIVE && subtype == SubType.DOCUMENT) return TypeNames.GOOGLE_DRIVE_DOCS;
  if (type === Type.GOOGLE_DRIVE && subtype == SubType.SPREADSHEET) return TypeNames.GOOGLE_DRIVE_SHEETS;
  if (type === Type.GOOGLE_DRIVE && subtype == SubType.PRESENTATION) return TypeNames.GOOGLE_DRIVE_SLIDES;

  if (type === Type.ONEDRIVE && subtype == SubType.WORD_DOCUMENT) return TypeNames.ONEDRIVE_WORD_DOCUMENT;
  if (type === Type.ONEDRIVE && subtype == SubType.POWERPOINT_PRESENTATION)
    return TypeNames.ONEDRIVE_POWERPOINT_PRESENTATION;
  if (type === Type.ONEDRIVE && subtype == SubType.EXCEL_SPREADSHEET) return TypeNames.ONEDRIVE_EXCEL_SPREADSHEET;
  if (type === Type.ONEDRIVE) return TypeNames.ONEDRIVE_FILE;

  if (type === Type.SALESFORCE) return TypeNames.SALESFORCE;
  if (type === Type.HUBSPOT) return TypeNames.HUBSPOT;
  if (type === Type.FIGMA) return TypeNames.FIGMA;
  if (type === Type.GITHUB) return TypeNames.GITHUB;
  if (type === Type.JIRA) return TypeNames.JIRA;
  if (type === Type.ASANA) return TypeNames.ASANA;

  return null;
};

type getNormalizedInsightProps = {
  surfaceItem;
};

// normalize the insights booleans to just one insight
export const getNormalizedInsight = ({ surfaceItem }: getNormalizedInsightProps) => {
  const insights = surfaceItem.insights;
  let normalizedInsight;
  if (insights.blocked) normalizedInsight = InsightType.BLOCKED;
  else if (insights.active) normalizedInsight = InsightType.ACTIVE;
  else if (insights.new) normalizedInsight = InsightType.NEW;

  return normalizedInsight;
};
